import { render, staticRenderFns } from "./ServiceCardGroup.vue?vue&type=template&id=141d5332&"
import script from "./ServiceCardGroup.vue?vue&type=script&lang=ts&"
export * from "./ServiceCardGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports